export default "__VITE_ASSET__DVoTgn4g__"